<template>
    <div>
        <PrizificPageBuilder
            v-if="useActualPage(EComponents.WINNERS_PAGE)"
            :page="useActualPage(EComponents.WINNERS_PAGE)"
        />
    </div>
</template>

<script setup>
import { usePagesStore } from "@/store/pages";
import { useWinnersStore } from "@/store/components/winnersList/winnersList";
import { useCampaignDataStore } from "@/store/campaign/campaignData";
import { EComponents } from "~~/enums/PrizificPageBuilder/EComponents";
import { EPrizeType } from "~~/enums/Campaign/EPrizeType";
import { storeToRefs } from "pinia";

const pageStore = usePagesStore();
const winnersStore = useWinnersStore();
const campaignDataStore = useCampaignDataStore();
const { getPage } = storeToRefs(pageStore);

onServerPrefetch(async () => {
    try {
        await pageStore.getPageFromServer(EComponents.WINNERS_PAGE);
    } catch (e) {
        console.error("On Server Prefetch error in Winners page", e);
    }
});

try {
    winnersStore.getWinners(EPrizeType.DAILY);
    winnersStore.getWinners(EPrizeType.WEEKLY);
    winnersStore.getWinners(EPrizeType.MONTHLY);
    winnersStore.getWinners(EPrizeType.MAIN);
} catch (error) {
    console.log("Error", error);
}

onMounted(async () => {
    try {
        if (!pageStore.getPage(EComponents.WINNERS_PAGE)) {
            await pageStore.getPageFromServer(EComponents.WINNERS_PAGE);
        }
    } catch (e) {
        console.error("On Mounted error in Winners page", e);
    }

    try {
        winnersStore.getWinners(EPrizeType.DAILY);
        winnersStore.getWinners(EPrizeType.WEEKLY);
        winnersStore.getWinners(EPrizeType.MONTHLY);
        winnersStore.getWinners(EPrizeType.MAIN);
    } catch (error) {
        console.log("Error", error);
    }
});
</script>

<style lang="scss"></style>
